export class Comment {
  Id: number;
  ActivityId: string;
  Text: string;
  Type: string;
  CreateDate: Date;
  CreatedBy: string;
}
